import { render, staticRenderFns } from "./AcademyLanding.vue?vue&type=template&id=e30f0840&"
import script from "./AcademyLanding.vue?vue&type=script&lang=js&"
export * from "./AcademyLanding.vue?vue&type=script&lang=js&"
import style0 from "./AcademyLanding.vue?vue&type=style&index=0&id=e30f0840&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports